var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00008 13.8333C10.774 13.8333 13.8334 10.774 13.8334 7C13.8334 3.22606 10.774 0.166672 7.00008 0.166672C3.22614 0.166672 0.166748 3.22606 0.166748 7C0.166748 10.774 3.22614 13.8333 7.00008 13.8333ZM12.3334 7C12.3334 9.94552 9.9456 12.3333 7.00008 12.3333C4.05456 12.3333 1.66675 9.94552 1.66675 7C1.66675 4.05449 4.05456 1.66667 7.00008 1.66667C9.9456 1.66667 12.3334 4.05449 12.3334 7ZM7.75008 3.66667C7.75008 3.25246 7.41429 2.91667 7.00008 2.91667C6.58587 2.91667 6.25008 3.25246 6.25008 3.66667V6.58578C6.25008 7.0499 6.43445 7.49502 6.76264 7.82321L7.80308 8.86366C8.09597 9.15656 8.57085 9.15656 8.86374 8.86367C9.15664 8.57078 9.15664 8.09591 8.86375 7.80301L7.8233 6.76255C7.77642 6.71567 7.75008 6.65208 7.75008 6.58578V3.66667Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/ClockIcon.3755b017f7cb86dcfa038b2ebc3ef7af.svg";
export { ForwardRef as ReactComponent };